import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

const initialState = {
  isLoadStatus: false,
  isLoadPrice: false,
  isLoadStock: false,
  isLoadCheckTrack: false,
};

export const statusTiki = createAsyncThunk(
  "Tiki/statusTiki",
  async (data) => {
    const response = await http.post("/update-status-tiki", data);
    return response.data.data;
  }
);

export const updatePriceTiki = createAsyncThunk(
  "Tiki/updatePriceTiki",
  async (data) => {
    const response = await http.post("/sync-price-tiki", data);
    return response.data.data;
  }
);

export const updateStockTiki = createAsyncThunk(
  "Tiki/updateStockTiki",
  async (data) => {
    const response = await http.post("/sync-stock-tiki", data);
    return response.data.data;
  }
);

export const checkTrackTiki = createAsyncThunk(
  "Tiki/checkTrackTiki",
  async (data) => {
    const response = await http.post("/check-track-tiki", data);
    return response.data.data;
  }
);

const updateStatusTikiSlice = createSlice({
  name: "updateStatusTiki",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(statusTiki.pending, (state) => { state.isLoadStatus = true; })
      .addCase(statusTiki.fulfilled, (state) => { state.isLoadStatus = false; })
      .addCase(statusTiki.rejected, (state) => { state.isLoadStatus = false; })
      .addCase(updatePriceTiki.pending, (state) => { state.isLoadPrice = true; })
      .addCase(updatePriceTiki.fulfilled, (state) => { state.isLoadPrice = false; })
      .addCase(updatePriceTiki.rejected, (state) => { state.isLoadPrice = false; })
      .addCase(updateStockTiki.pending, (state) => { state.isLoadStock = true; })
      .addCase(updateStockTiki.fulfilled, (state) => { state.isLoadStock = false; })
      .addCase(updateStockTiki.rejected, (state) => { state.isLoadStock = false; })
      .addCase(checkTrackTiki.pending, (state) => { state.isLoadCheckTrack = true; })
      .addCase(checkTrackTiki.fulfilled, (state) => { state.isLoadCheckTrack = false; })
      .addCase(checkTrackTiki.rejected, (state) => { state.isLoadCheckTrack = false; });
  },
});

export default updateStatusTikiSlice.reducer;
